import { Component } from '@angular/core';

import { Router } from '@angular/router';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { GalleriaModule } from 'primeng/galleria';
import { CarouselModule } from 'primeng/carousel';

@Component({
    selector: 'app-media-widget',
    standalone: true,
    imports: [
    ButtonModule,
    GalleriaModule,
    CarouselModule,
    RouterModule
],
    templateUrl: './mediawidget.component.html',
    styleUrl: './mediawidget.component.scss',
})
export class MediaWidget {
    carouselResponsiveOptions: any[] = [
        {
            breakpoint: '1024px',
            numVisible: 3,
            numScroll: 3
        },
        {
            breakpoint: '768px',
            numVisible: 2,
            numScroll: 2
        },
        {
            breakpoint: '560px',
            numVisible: 1,
            numScroll: 1
        }
    ];

    images: any[] = [
        {
            itemImageSrc: "media/Akksi01-Streamer.jpg",
            alt: "Akksi01-Streamer",
            title1: "Streamt live Events von unserer Liga und ist in anderen Ligen aktiv.",
            twitchLink: "akksi01",
            youtubeLink: "@Akksi01",
            instagramLink: "twitch_akksi01",
            tiktokLink: "@akksi01"
        },
        {
            itemImageSrc: "media/Seves123-Streamer.jpg",
            alt: "Seves123-Streamer",
            title1: "Junger angehender Stern. Streamt live und erstellt Zusammenfassungen",
            youtubeLink: "@Seves123",
        },
        {
            itemImageSrc: "media/SimRaceNick-Youtuber.png",
            alt: "SimRaceNick-Youtuber",
            title1: "SimRaceNick ist ein Youtuber, der regelmäßig Videos von unserer Liga hochlädt. Ab und zu ist er auch im Livestream dabei.",
            youtubeLink: "@SimRaceNick",
            twitchLink: "simracenick"
        },
        /*
        {
            itemImageSrc: "media/GTT-Flori-Streamer.png",
            alt: "GTT-Flori-Streamer",
            title1: "Fährt in unserer Liga und streamt regelmäßig auf Youtube und Twitch.", 
            youtubeLink: "@flo2144",
            twitchLink: "gttflori"
        },
        */

    ];

    constructor(private router: Router) {}

    navigateToExternalPage(page: string, content: string): void {
        if (page === 'youtube') {
            window.open('https://www.youtube.com/' + content, '_blank');
        } else if (page === 'twitch') {
            window.open('https://www.twitch.tv/' + content, '_blank');
        } else if (page === 'instagram') {
            window.open('https://www.instagram.com/' + content, '_blank');
        } else if (page === 'tiktok') {
            window.open('https://www.tiktok.com/' + content, '_blank');
        }
        //this.router.navigate(['/playerDetails', playerId]);
    }

}
